const mutations = {
  //保存登录时用户的个人信息
  setUserInfo(state, userInfo) {    
    state.userInfo=userInfo;
       sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
   }
  }
  // 需要默认导出，不要忘记了
  export default mutations